import { PushHistoryTable } from './PushHistoryTable';
import { fixtureProps, linkedRow } from './fixtures';
const meta = {
    title: 'Features/Settings/Technicians/PushHistory/PushHistoryTable',
    component: PushHistoryTable,
    parameters: { layout: 'padded' },
    args: {
        rows: fixtureProps.rows,
        timeZone: fixtureProps.timeZone,
        platformUnavailable: false,
        tinted: true,
        expanded: {}
    }
};
export default meta;
export const Tinted = {};
export const Plain = { args: { tinted: false } };
export const LinkedRowExpanded = { args: { expanded: { [linkedRow.id]: true } } };
